<template>
  <footer>
    <span>
      Made with hate to people who can't search by
      <a href="https://github.com/DMax-YT" target="_blank">DMax</a>
    </span>
  </footer>
</template>
